import { useMemo } from 'react';
import type { ScenarioPersonaDto, PersonaUsage } from '@/api-gen/api.schemas';

export interface UsageValidationResult {
  isValid: boolean;
  message?: string;
}

/**
 * Custom hook for validating persona usage changes with business rules
 */
export const usePersonaUsageValidation = (
  currentPersonas: ScenarioPersonaDto[],
  translate: (key: string, params?: any) => string
) => {
  const validateUsageChange = useMemo(() => {
    return (personaId: number, newUsages: PersonaUsage[]): UsageValidationResult => {
      // Always return valid - automatic removal logic handles all conflicts seamlessly
      return { isValid: true };
    };
  }, [currentPersonas, translate]);

  return { validateUsageChange };
};
